// Keep these timings centralized so the editor showcase, website reveal, and tutorial prompt
// remain perfectly in sync.

// Global time scale for the creation showcase.
// 1.0 = original timing, lower = faster, higher = slower.
export const WEBSITE_CREATION_SHOWCASE_TIME_SCALE = 0.75;

const BASE_DURATION_MS = 3500;
const BASE_EXIT_MS = 200;
const BASE_FINAL_BLAST_MS = 800;
const BASE_PROMPT_LEAD_MS = 300; // show the tutorial prompt slightly before the final blast starts

// Duration the showcase runs before it begins its exit transition.
export const WEBSITE_CREATION_SHOWCASE_DURATION_MS = Math.round(
  BASE_DURATION_MS * WEBSITE_CREATION_SHOWCASE_TIME_SCALE,
);

// Exit fade duration for the showcase overlay (website should reveal after this completes).
export const WEBSITE_CREATION_SHOWCASE_EXIT_MS = Math.round(
  BASE_EXIT_MS * WEBSITE_CREATION_SHOWCASE_TIME_SCALE,
);

// The final "blast of light" duration at the end of the showcase.
// Keep this at a fixed 800ms (per product preference) even when the rest of the showcase is time-scaled.
export const WEBSITE_CREATION_SHOWCASE_FINAL_BLAST_MS = BASE_FINAL_BLAST_MS;

// How much earlier than the final blast start we show the tutorial prompt.
export const WEBSITE_CREATION_SHOWCASE_PROMPT_LEAD_MS = Math.round(
  BASE_PROMPT_LEAD_MS * WEBSITE_CREATION_SHOWCASE_TIME_SCALE,
);

// When the tutorial prompt should appear (we show it during the final blast so it feels snappy,
// but the website reveal still happens after the full showcase completes).
export const WEBSITE_CREATION_SHOWCASE_PROMPT_DELAY_MS = Math.max(
  0,
  WEBSITE_CREATION_SHOWCASE_DURATION_MS -
    WEBSITE_CREATION_SHOWCASE_FINAL_BLAST_MS -
    WEBSITE_CREATION_SHOWCASE_PROMPT_LEAD_MS,
);

// Total time from showcase start until the website is revealed.
export const WEBSITE_CREATION_SHOWCASE_TOTAL_MS =
  WEBSITE_CREATION_SHOWCASE_DURATION_MS + WEBSITE_CREATION_SHOWCASE_EXIT_MS;

